import { DateButton } from "shared/components/date-controls/date-picker/DateButton.styles";
import HStack from "shared/components/layout/stack/HStack";
import { SPACING_VALUES } from "shared/config/spacing";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";
import styled from "styled-components";

export const StyledHStack = styled(HStack)`
    width: 100%;
    flex-wrap: wrap;
    gap: 3px;
    padding-left: 16px;
`;

export const StyledTertiaryButton = styled(DateButton)`
    border-radius: 160px;
    width: 53px;
    height: 24px;
    marginright: 4px;
`;

export const YearMonthVStack = styled(VStack)`
    gap: ${SPACING_VALUES.Zero_5};
`;

export const WrapperVStack = styled(VStack)`
    gap: 24px;
    padding-top: 9px;
`;

export const StyledYearText = styled(Text)`
    padding: 0 16px;
`;
